module.exports = __webpack_public_path__ + "static/media/slider_6_master_user_es.3c755097.svg";